"use strict";

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.unscopables.flat-map");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash"));

var _prefixNegativeModifiers = _interopRequireDefault(require("../util/prefixNegativeModifiers"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default() {
  return function (_ref) {
    var addUtilities = _ref.addUtilities,
        e = _ref.e,
        theme = _ref.theme,
        variants = _ref.variants;
    var generators = [function (size, modifier) {
      return _defineProperty({}, ".".concat(e((0, _prefixNegativeModifiers.default)('m', modifier))), {
        margin: "".concat(size)
      });
    }, function (size, modifier) {
      var _ref3;

      return _ref3 = {}, _defineProperty(_ref3, ".".concat(e((0, _prefixNegativeModifiers.default)('my', modifier))), {
        'margin-top': "".concat(size),
        'margin-bottom': "".concat(size)
      }), _defineProperty(_ref3, ".".concat(e((0, _prefixNegativeModifiers.default)('mx', modifier))), {
        'margin-left': "".concat(size),
        'margin-right': "".concat(size)
      }), _ref3;
    }, function (size, modifier) {
      var _ref4;

      return _ref4 = {}, _defineProperty(_ref4, ".".concat(e((0, _prefixNegativeModifiers.default)('mt', modifier))), {
        'margin-top': "".concat(size)
      }), _defineProperty(_ref4, ".".concat(e((0, _prefixNegativeModifiers.default)('mr', modifier))), {
        'margin-right': "".concat(size)
      }), _defineProperty(_ref4, ".".concat(e((0, _prefixNegativeModifiers.default)('mb', modifier))), {
        'margin-bottom': "".concat(size)
      }), _defineProperty(_ref4, ".".concat(e((0, _prefixNegativeModifiers.default)('ml', modifier))), {
        'margin-left': "".concat(size)
      }), _ref4;
    }];

    var utilities = _lodash.default.flatMap(generators, function (generator) {
      return _lodash.default.flatMap(theme('margin'), generator);
    });

    addUtilities(utilities, variants('margin'));
  };
}